// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Loader2, X, AlertCircle } from "lucide-react";
// import { uploadToCloudinary } from "../../../utils/cloudinary";
// import Swal from "sweetalert2";

// const CareerUpdateModal = ({ career, onClose, onSuccess }) => {
//   const [formData, setFormData] = useState({
//     position: "",
//     jobType: "Full Time",
//     company: {
//       companyLogo: null,
//       companyName: "",
//       jobLocation: "",
//     },
//     jobDetail: {
//       salary: "",
//       salaryCurrency: "INR",
//       jobOpenings: "",
//     },
//   });

//   const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (career) {
//       setFormData({
//         position: career.position || "",
//         jobType: career.jobType || "Full Time",
//         company: {
//           companyLogo: career.company?.companyLogo || null,
//           companyName: career.company?.companyName || "",
//           jobLocation: career.company?.jobLocation || "",
//         },
//         jobDetail: {
//           salary: career.jobDetail?.salary || "",
//           salaryCurrency: career.jobDetail?.salaryCurrency || "INR",
//           jobOpenings: career.jobDetail?.jobOpenings?.toString() || "",
//         },
//       });

//       // Set company logo preview if it exists
//       if (career.company?.companyLogo) {
//         setCompanyLogoPreview(career.company.companyLogo);
//       }
//     }
//   }, [career]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCompanyChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, [field]: value },
//     }));
//   };

//   const handleJobDetailChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       jobDetail: { ...prev.jobDetail, [field]: value },
//     }));
//   };

//   const handleCompanyLogo = (e) => {
//     const file = e.target.files[0];
//     setFormData((prev) => ({
//       ...prev,
//       company: { ...prev.company, companyLogo: file },
//     }));
//     const reader = new FileReader();
//     reader.onloadend = () => setCompanyLogoPreview(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const validate = () => {
//     if (!formData.position.trim()) return "Position is required";
//     if (!formData.jobType.trim()) return "Job type is required";
//     if (!formData.company.companyName.trim()) return "Company name is required";
//     if (!formData.company.jobLocation.trim()) return "Job location is required";
//     if (!formData.jobDetail.salary.trim()) return "Salary is required";
//     if (!formData.jobDetail.salaryCurrency.trim())
//       return "Salary currency is required";
//     if (!formData.jobDetail.jobOpenings.trim())
//       return "Job openings is required";
//     const jobOpenings = parseInt(formData.jobDetail.jobOpenings);
//     if (isNaN(jobOpenings) || jobOpenings < 1) {
//       return "Job openings must be a positive number";
//     }

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validation = validate();
//     if (validation) return setError(validation);

//     setLoading(true);
//     setError(null);

//     try {
//       let companyLogoUrl = formData.company.companyLogo;
//       if (formData.company.companyLogo instanceof File) {
//         companyLogoUrl = await uploadToCloudinary(formData.company.companyLogo);
//       }
//       const companyData = {
//         companyLogo: companyLogoUrl,
//         companyName: formData.company.companyName,
//         jobLocation: formData.company.jobLocation,
//       };
//       const jobDetailData = {
//         salary: formData.jobDetail.salary,
//         salaryCurrency: formData.jobDetail.salaryCurrency,
//         jobOpenings: parseInt(formData.jobDetail.jobOpenings),
//       };
//       const submitData = {
//         position: formData.position,
//         jobType: formData.jobType,
//         company: companyData,
//         jobDetail: jobDetailData,
//       };

//       const res = await axios.put(
//         `${process.env.REACT_APP_API_URL}/career/update-career/${career._id}`,
//         submitData
//         // { withCredentials: true }
//       );

//       if (res.data.success) {
//         onSuccess();
//         onClose();
//         Swal.fire("Updated", "Career updated successfully.", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.message || "Failed to update career");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!career) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto">
//         <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl">
//           <h2 className="text-lg font-semibold text-white">Update Career</h2>
//           <button
//             onClick={onClose}
//             className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
//           {error && (
//             <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
//               <AlertCircle className="w-5" /> {error}
//             </div>
//           )}

//           {/* Basic Information */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Position *
//               </label>
//               <input
//                 type="text"
//                 name="position"
//                 value={formData.position}
//                 onChange={handleInputChange}
//                 placeholder="Enter position"
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               />
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Job Type *
//               </label>
//               <select
//                 name="jobType"
//                 value={formData.jobType}
//                 onChange={handleInputChange}
//                 className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//               >
//                 <option value="Full Time">Full Time</option>
//                 <option value="Part Time">Part Time</option>
//                 <option value="Internship">Internship</option>
//                 <option value="Freelance">Freelance</option>
//               </select>
//             </div>
//           </div>

//           {/* Company Information */}
//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">
//               Company Information *
//             </h4>

//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Company Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.companyName}
//                   onChange={(e) =>
//                     handleCompanyChange("companyName", e.target.value)
//                   }
//                   placeholder="Enter company name"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Job Location *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.company.jobLocation}
//                   onChange={(e) =>
//                     handleCompanyChange("jobLocation", e.target.value)
//                   }
//                   placeholder="Enter job location"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block font-semibold text-gray-700 mb-1">
//                 Company Logo
//               </label>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleCompanyLogo}
//                 className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
//               />
//               {companyLogoPreview && (
//                 <img
//                   src={companyLogoPreview}
//                   alt="Company logo preview"
//                   className="w-28 h-28 mt-2 rounded object-cover"
//                 />
//               )}
//             </div>
//           </div>

//           {/* Job Details */}
//           <div className="border rounded-xl p-4 space-y-4">
//             <h4 className="font-semibold text-gray-800">Job Details *</h4>
//             <div className="grid md:grid-cols-3 gap-4">
//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Salary *
//                 </label>
//                 <input
//                   type="text"
//                   value={formData.jobDetail.salary}
//                   onChange={(e) =>
//                     handleJobDetailChange("salary", e.target.value)
//                   }
//                   placeholder="e.g., 70000"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Currency *
//                 </label>
//                 <select
//                   value={formData.jobDetail.salaryCurrency}
//                   onChange={(e) =>
//                     handleJobDetailChange("salaryCurrency", e.target.value)
//                   }
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 >
//                   <option value="INR">INR</option>
//                   <option value="USD">USD</option>
//                   <option value="EUR">EUR</option>
//                   <option value="GBP">GBP</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block font-semibold text-gray-700 mb-1">
//                   Job Openings *
//                 </label>
//                 <input
//                   type="number"
//                   min="1"
//                   value={formData.jobDetail.jobOpenings}
//                   onChange={(e) =>
//                     handleJobDetailChange("jobOpenings", e.target.value)
//                   }
//                   placeholder="e.g., 5"
//                   className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="flex items-center gap-5 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 w-full py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="px-5 py-2 w-full rounded-lg bg-[#0BB6D9] text-white hover:bg-cyan-700 flex items-center justify-center gap-2"
//             >
//               {loading && <Loader2 className="animate-spin w-4 h-4" />}
//               <span>Update</span>
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CareerUpdateModal;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Loader2, X, AlertCircle } from "lucide-react";
import { uploadToCloudinary } from "../../../utils/cloudinary";
import Swal from "sweetalert2";

const CareerUpdateModal = ({ career, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    position: "",
    companyLogo: null,
    jobOpenings: "",
  });

  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (career) {
      setFormData({
        position: career.position || "",
        companyLogo: career.companyLogo || null,
        jobOpenings: career.jobOpenings?.toString() || "",
      });

      // Set company logo preview if it exists
      if (career.companyLogo) {
        setCompanyLogoPreview(career.companyLogo);
      }
    }
  }, [career]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyLogo = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, companyLogo: file }));
      const reader = new FileReader();
      reader.onloadend = () => setCompanyLogoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validate = () => {
    if (!formData.position.trim()) return "Position is required";
    if (!formData.jobOpenings.trim()) return "Job openings is required";

    const jobOpenings = parseInt(formData.jobOpenings);
    if (isNaN(jobOpenings) || jobOpenings < 1) {
      return "Job openings must be a positive number";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = validate();
    if (validation) return setError(validation);

    setLoading(true);
    setError(null);

    try {
      let companyLogoUrl = formData.companyLogo;
      
      // Only upload if a new file was selected
      if (formData.companyLogo instanceof File) {
        companyLogoUrl = await uploadToCloudinary(formData.companyLogo);
      }

      const submitData = {
        position: formData.position,
        companyLogo: companyLogoUrl,
        jobOpenings: parseInt(formData.jobOpenings),
      };

      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/career/update-career/${career._id}`,
        submitData
      );

      if (res.data.success) {
        onSuccess();
        onClose();
        Swal.fire("Updated", "Career updated successfully.", "success");
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to update career");
    } finally {
      setLoading(false);
    }
  };

  if (!career) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl">
          <h2 className="text-lg font-semibold text-white">Update Career</h2>
          <button
            onClick={onClose}
            className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && (
            <div className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-3 rounded-lg">
              <AlertCircle className="w-5" /> {error}
            </div>
          )}

          {/* Position */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Position *
            </label>
            <input
              type="text"
              name="position"
              value={formData.position}
              onChange={handleInputChange}
              placeholder="Enter position"
              className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
              required
            />
          </div>

          {/* Company Logo */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Company Logo
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleCompanyLogo}
              className="w-full text-sm text-gray-500 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#0bb6d9] file:text-white hover:file:bg-[#069ab7]"
            />
            {companyLogoPreview && (
              <img
                src={companyLogoPreview}
                alt="Company logo preview"
                className="w-28 h-28 mt-2 rounded object-cover"
              />
            )}
          </div>

          {/* Job Openings */}
          <div>
            <label className="block font-semibold text-gray-700 mb-1">
              Job Openings *
            </label>
            <input
              type="number"
              name="jobOpenings"
              min="1"
              value={formData.jobOpenings}
              onChange={handleInputChange}
              placeholder="e.g., 5"
              className="w-full border rounded-lg p-2.5 focus:ring-2 focus:ring-[#0BB6D9] outline-none"
              required
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-5 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 w-full py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 w-full rounded-lg bg-[#0BB6D9] text-white hover:bg-cyan-700 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="animate-spin w-4 h-4" />}
              <span>Update Career</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerUpdateModal;